window.bundleDataI = {
"Ian-boy": {
displayName: "Ian",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ian Personalized Coloring Experience",
variantId: "49343639388397",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ian_final_cover.png?v=1772483899",
price: "$14.99",
preorder: true
},
{
title: "Ian Dragon Holographic Sticker",
variantId: "49933770883309",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ian_holographic_sticker.png?v=1779648210",
price: "$4.99",
preorder: false
},
{
title: "Ian Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Imogen-girl": {
displayName: "Imogen",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Imogen Personalized Coloring Experience",
variantId: "49299063275757",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Imogen_final_cover.png?v=1773766535",
price: "$14.99",
preorder: true
},
{
title: "Imogen Unicorn Holographic Sticker",
variantId: "49933772718317",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Imogen_holographic_sticker.png?v=1779489479",
price: "$4.99",
preorder: false
},
{
title: "Imogen Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Iris-girl": {
displayName: "Iris",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Iris Personalized Coloring Experience",
variantId: "49537123516653",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Iris_final_cover.png?v=1773200666",
price: "$14.99",
preorder: true
},
{
title: "Iris Unicorn Holographic Sticker",
variantId: "49933757612269",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Iris_holographic_sticker.png?v=1779489479",
price: "$4.99",
preorder: false
},
{
title: "Iris Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Isaac-boy": {
displayName: "Isaac",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Isaac Personalized Coloring Experience",
variantId: "49351711949037",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Isaac_final_cover.png?v=1772483901",
price: "$14.99",
preorder: true
},
{
title: "Isaac Dragon Holographic Sticker",
variantId: "49933770850541",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Isaac_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "Isaac Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Isabel-girl": {
displayName: "Isabel",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Isabel Personalized Coloring Experience",
variantId: "49537585479917",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Isabel_final_cover.png?v=1773200665",
price: "$14.99",
preorder: true
},
{
title: "Isabel Unicorn Holographic Sticker",
variantId: "49933757415661",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Isabel_holographic_sticker.png?v=1779489479",
price: "$4.99",
preorder: false
},
{
title: "Isabel Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Isabella-girl": {
displayName: "Isabella",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Isabella Personalized Coloring Experience",
variantId: "49537107362029",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Isabella_final_cover.png?v=1773200665",
price: "$14.99",
preorder: true
},
{
title: "Isabella Unicorn Holographic Sticker",
variantId: "49933757710573",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Isabella_holographic_sticker.png?v=1779489479",
price: "$4.99",
preorder: false
},
{
title: "Isabella Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Isabelle-girl": {
displayName: "Isabelle",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Isabelle Personalized Coloring Experience",
variantId: "49537154384109",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Isabelle_final_cover.png?v=1773200665",
price: "$14.99",
preorder: true
},
{
title: "Isabelle Unicorn Holographic Sticker",
variantId: "49933757579501",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Isabelle_holographic_sticker.png?v=1779489479",
price: "$4.99",
preorder: false
},
{
title: "Isabelle Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Isaiah-boy": {
displayName: "Isaiah",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Isaiah Personalized Coloring Experience",
variantId: "49351714537709",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Isaiah_final_cover.png?v=1772483900",
price: "$14.99",
preorder: true
},
{
title: "Isaiah Dragon Holographic Sticker",
variantId: "49933770817773",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Isaiah_holographic_sticker.png?v=1779648205",
price: "$4.99",
preorder: false
},
{
title: "Isaiah Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Isla-girl": {
displayName: "Isla",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Isla Personalized Coloring Experience",
variantId: "49537870332141",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Isla_final_cover.png?v=1773200665",
price: "$14.99",
preorder: true
},
{
title: "Isla Unicorn Holographic Sticker",
variantId: "49933757350125",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Isla_holographic_sticker.png?v=1779489479",
price: "$4.99",
preorder: false
},
{
title: "Isla Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Israel-boy": {
displayName: "Israel",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Israel Personalized Coloring Experience",
variantId: "49351716110573",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Israel_final_cover.png?v=1772483899",
price: "$14.99",
preorder: true
},
{
title: "Israel Dragon Holographic Sticker",
variantId: "49933770785005",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Israel_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Israel Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Ivan-boy": {
displayName: "Ivan",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ivan Personalized Coloring Experience",
variantId: "49351717650669",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ivan_final_cover.png?v=1772483901",
price: "$14.99",
preorder: true
},
{
title: "Ivan Dragon Holographic Sticker",
variantId: "49933770752237",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ivan_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "Ivan Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Ivy-girl": {
displayName: "Ivy",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ivy Personalized Coloring Experience",
variantId: "49537111982317",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ivy_final_cover.png?v=1773200665",
price: "$14.99",
preorder: true
},
{
title: "Ivy Unicorn Holographic Sticker",
variantId: "49933757677805",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ivy_holographic_sticker.png?v=1779489480",
price: "$4.99",
preorder: false
},
{
title: "Ivy Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Izabella-girl": {
displayName: "Izabella",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Izabella Personalized Coloring Experience",
variantId: "49537167458541",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Izabella_final_cover.png?v=1773200666",
price: "$14.99",
preorder: true
},
{
title: "Izabella Unicorn Holographic Sticker",
variantId: "49933757546733",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Izabella_holographic_sticker.png?v=1779489479",
price: "$4.99",
preorder: false
},
{
title: "Izabella Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Izzy-girl": {
displayName: "Izzy",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Izzy Personalized Coloring Experience",
variantId: "49537888387309",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Izzy_final_cover.png?v=1773200665",
price: "$14.99",
preorder: true
},
{
title: "Izzy Unicorn Holographic Sticker",
variantId: "49933757317357",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Izzy_holographic_sticker.png?v=1779489479",
price: "$4.99",
preorder: false
},
{
title: "Izzy Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} 

};